import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../app/store";
import { postActivateAccount } from "../authentificationSlice";
import { AccountActivation } from "../authModel";
import { useLocation, useNavigate } from "react-router-dom";
import { GetServerEmailError } from "../../../app/validation";
import { useEmailErrorMessage } from "../../../UIComponents/Form/EmailField";
import { LoadingPage } from "../../CommonPages/loadingPage";
import ActivateAccountCard from "./activateAccountCard";
import { Dialog } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import SuccessCard from "../../CommonPages/successCard";

export function ActivateAccount() {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState<string | undefined>();
    const [messsage, setMesssage] = useState("");
    const [success, setSuccess] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const { t } = useTranslation();
    const getEmailError = useEmailErrorMessage();
    const activateAccountData = useSelector((state: RootState) => state.AuthentificationSlice);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const handleOpenDialog = () => setOpenDialog(!openDialog);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        submitFunction(email);
    };

    const submitFunction = (email: string) => {
        const emailProblem = getEmailError(email);
        if (emailProblem) {
            setEmailError(emailProblem);
            return;
        }
        let code = params.get("code");
        const activateAccountReq: AccountActivation = {
            username: email,
            code: code ?? "",
        };
        dispatch(postActivateAccount(activateAccountReq));
    };

    useEffect(() => {
        if (activateAccountData.statusCode === '200' || activateAccountData.statusCode === 'OK') {
            setSuccess(true);
            setMesssage(t("AccountIsActivated"));
            handleOpenDialog();
        }
        else if (activateAccountData.statusCode !== '') {
            // A 400 on the email is a fixable typo, so it goes on the field.
            const serverEmailError = GetServerEmailError(activateAccountData.statusCode, activateAccountData.error);
            if (serverEmailError) {
                setEmailError(serverEmailError);
                return;
            }
            setSuccess(false);
            setMesssage(activateAccountData.error ?? t("AnErrorOccurred"));
            handleOpenDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activateAccountData.statusCode])

    useEffect(() => {
        if (openDialog === false && success === true && (activateAccountData.statusCode === '200' || activateAccountData.statusCode === 'OK')) {
            navigate('/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openDialog])

    if (activateAccountData.isLoading) {
        return (LoadingPage(activateAccountData.isLoading))
    }

    return (
        <div className="flex justify-center m-[5%]">
            <form className="space-y-5" onSubmit={handleSubmit}>
                <ActivateAccountCard onClickFunction={submitFunction} setEmailForm={setEmail} emailError={emailError} onEmailErrorClear={() => setEmailError(undefined)} />
                <input type="submit" style={{ display: "none" }} />
            </form>
            <Dialog open={openDialog} handler={handleOpenDialog} size="xs" animate={{ mount: { scale: 1, y: 0 }, unmount: { scale: 0.9, y: -100 } }}>
                <SuccessCard onClickFunction={handleOpenDialog} text={messsage} success={success} />
            </Dialog>
        </div>
    );
}
